export const readFileAsyncAsArrayBuffer = (file) => new Promise((resolve) => {
  const reader = new window.FileReader()
  reader.onload = () => resolve(new Uint8Array(reader.result))
  reader.readAsArrayBuffer(file)
})
